
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const bonusApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listBonuss: builder.query ({
      query: (params) => `v2/bonus/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Bonus"]
    }),
    getBonus: builder.query ({
      query: (bonus_id) => `v2/bonus/${bonus_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Bonus"]
    }),

    updateBonus: builder.mutation ({
      query: ({bonus_id, data}) => ({
        url: `v2/bonus/${bonus_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Bonus"]
    }),
    deleteBonus: builder.mutation ({
      query: (bonus_id) => ({
        url: `v2/bonus/${bonus_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Bonus"]
    }),
    createBonus: builder.mutation ({
      query: (data) => ({
        url: `v2/bonus/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Bonus"]
    }),
  })
})


export const {
  useListBonussQuery,
  useLazyListBonussQuery,
  useGetBonusQuery,
  useLazyGetBonusQuery,

  useUpdateBonusMutation,
  useDeleteBonusMutation,
  useCreateBonusMutation
} = bonusApi
